import React, { useContext, useState } from 'react';

import GraphContainer from '../../../Graphs/graphContainer';
import Grid from '@mui/material/Grid2';
import Modal from '../../../Modals';
import Treemap from '../../../Graphs/treemap';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  modal: {
    backgroundColor: 'white',
    height: '85%',
    width: '90%',
    maxHeight: '600px',
    maxWidth: '1400px',
  },
}));

export default ({ context }) => {
  const classes = useStyles();
  const {
    setOpenControlsModal,
    ids,
    labels,
    loading,
    parents,
    values,
    customdata,
    hovertemplate,
    downloadCallback,
    title,
    onClick,
    zoomedNode,
    texttemplate,
    googleAnalyticsTag,
    message,
  } = useContext(context);
  const [open, setOpen] = useState(false);
  const showToggle = false;

  return (
    <>
      <GraphContainer
        open={open}
        setOpen={() => setOpen(true)}
        setOpenControlsModal={setOpenControlsModal}
        showToggle={showToggle}
        title={title}
        loading={loading}
        downloadCallback={downloadCallback}
        googleAnalyticsTag={googleAnalyticsTag}
      >
        <Treemap
          ids={ids}
          labels={labels}
          parents={parents}
          values={values}
          layout={{
            margin: { l: 5, r: 5, b: 10, t: 20 },
          }}
          hovertemplate={hovertemplate}
          customdata={customdata}
          loading={loading}
          onClick={onClick}
          level={zoomedNode}
          texttemplate={texttemplate}
          title={message}
        />
      </GraphContainer>
      <Modal
        handleClose={() => setOpen(false)}
        open={open}
        title="Chart Expansion"
        titleAlignedWithClose={true}
        styles={classes}
        disablePortal
      >
        <Grid container className={classes.root}>
          <GraphContainer
            open={open}
            setClose={() => setOpen(false)}
            setOpenControlsModal={setOpenControlsModal}
            showToggle={showToggle}
            title={title}
            loading={loading}
            downloadCallback={downloadCallback}
            googleAnalyticsTag={googleAnalyticsTag}
          >
            <Treemap
              ids={ids}
              labels={labels}
              parents={parents}
              values={values}
              layout={{
                margin: { l: 5, r: 5, b: 10, t: 20 },
              }}
              hovertemplate={hovertemplate}
              customdata={customdata}
              loading={loading}
              onClick={onClick}
              level={zoomedNode}
              texttemplate={texttemplate}
              title={message}
            />
          </GraphContainer>
        </Grid>
      </Modal>
    </>
  );
};
